import CreatePostContent from "../../../content/post/createPost";
import { Layout } from "../../../layout/page";

export function CreatePost() {
  return (
    <Layout>
      <CreatePostContent />
    </Layout>
  );
}
